// @flow
import typeof Cookies from 'browser-cookies';
import typeof Uuid from 'uuid/v4';
import type {
  GetBrowserSession,
  CreateBrowserSession,
} from '../../core/browserSession';

export const SESSION_KEY = 'DST_USER_SESSION';

export const getBrowserSession = (
  cookies: Cookies,
): GetBrowserSession => () => {
  return cookies.get(SESSION_KEY);
};

export const createBrowserSession = (
  cookies: Cookies,
  uuid: Uuid,
): CreateBrowserSession => () => {
  const id = uuid();
  const expires = new Date(Date.now() + (1000 * 60 * 30));
  cookies.set(SESSION_KEY, id, { expires });
  return id;
};
